

















































































































































import { Component, Vue } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import BedSvc, { RanapBedCapacityRow } from "@/services/LaporanRl1Ranap";
import SettingsSvc, { ConfigNomorSuratRow } from "@/services/SuperAdminSettings";

@Component
export default class SuperAdminSettingsPage extends Vue {
  tab = "bed";
  saving = false;

  // Bed capacity
  beds: RanapBedCapacityRow[] = [];
  kelasOptions: string[] = [];
  bedLoading = false;
  bedSearch = "";
  bedOnlyActive = false;
  bedDialog = false;
  bedForm: any = this.emptyBed();
  bedErr: Record<string, string[]> = {};
  bedHeaders = [
    { text: "Kode Unit", value: "unit_kode" },
    { text: "Unit", value: "unit_nama" },
    { text: "Kelas", value: "kelas" },
    { text: "Kapasitas", value: "kapasitas" },
    { text: "Efektif", value: "tgl_efektif" },
    { text: "Nonaktif", value: "tgl_nonaktif" },
    { text: "Status", value: "is_active" },
    { text: "Aksi", value: "actions", sortable: false }
  ];

  // Nomor surat
  nomor: ConfigNomorSuratRow[] = [];
  nomorLoading = false;
  nomorSearch = "";
  nomorDialog = false;
  nomorForm: any = this.emptyNomor();
  nomorErr: Record<string, string[]> = {};
  nomorHeaders = [
    { text: "ID", value: "id" },
    { text: "Nama Surat (key)", value: "nama_surat" },
    { text: "Start", value: "start" },
    { text: "Aksi", value: "actions", sortable: false }
  ];

  async mounted() {
    await Promise.all([this.loadBeds(), this.loadNomor()]);
  }

  // ---------- Bed capacity ----------
  emptyBed() {
    return {
      id: null,
      unit_kode: "",
      kelas: "",
      kapasitas: 0,
      tgl_efektif: "",
      tgl_nonaktif: null,
      is_active: true,
      keterangan: ""
    };
  }

  async loadBeds() {
    this.bedLoading = true;
    try {
      const res = await BedSvc.listCapacities({
        unit_kode: this.bedSearch || undefined,
        only_active: this.bedOnlyActive || undefined
      });
      this.beds = res.data;
      this.kelasOptions = res.kelas_options;
    } finally {
      this.bedLoading = false;
    }
  }

  openBedDialog(item?: RanapBedCapacityRow) {
    this.bedErr = {};
    this.bedForm = item ? { ...item } : this.emptyBed();
    this.bedDialog = true;
  }

  async saveBed() {
    this.saving = true;
    this.bedErr = {};
    try {
      await BedSvc.saveCapacity(this.bedForm, this.bedForm.id || undefined);
      this.bedDialog = false;
      appModule.NoticeDelay("Kapasitas TT tersimpan");
      await this.loadBeds();
    } catch (e) {
      this.bedErr = e.response?.data?.errors || {};
    } finally {
      this.saving = false;
    }
  }

  async deleteBed(item: RanapBedCapacityRow) {
    if (!confirm(`Nonaktifkan kapasitas ${item.unit_kode} / ${item.kelas}?`)) return;
    try {
      await BedSvc.deleteCapacity(item.id);
      appModule.NoticeDelay("Kapasitas dinonaktifkan");
      await this.loadBeds();
    } catch (e) {
      /* handled */
    }
  }

  // ---------- Nomor surat ----------
  emptyNomor() {
    return { id: null, nama_surat: "", start: 1 };
  }

  async loadNomor() {
    this.nomorLoading = true;
    try {
      this.nomor = await SettingsSvc.listNomorSurat(this.nomorSearch);
    } finally {
      this.nomorLoading = false;
    }
  }

  openNomorDialog(item?: ConfigNomorSuratRow) {
    this.nomorErr = {};
    this.nomorForm = item ? { ...item } : this.emptyNomor();
    this.nomorDialog = true;
  }

  async saveNomor() {
    this.saving = true;
    this.nomorErr = {};
    try {
      if (this.nomorForm.id) {
        await SettingsSvc.updateNomorSurat(this.nomorForm.id, this.nomorForm);
      } else {
        await SettingsSvc.createNomorSurat(this.nomorForm);
      }
      this.nomorDialog = false;
      appModule.NoticeDelay("Penomoran surat tersimpan");
      await this.loadNomor();
    } catch (e) {
      this.nomorErr = e.response?.data?.errors || {};
    } finally {
      this.saving = false;
    }
  }

  async deleteNomor(item: ConfigNomorSuratRow) {
    if (!confirm(`Hapus penomoran "${item.nama_surat}"?`)) return;
    try {
      await SettingsSvc.deleteNomorSurat(item.id);
      appModule.NoticeDelay("Penomoran dihapus");
      await this.loadNomor();
    } catch (e) {
      /* handled */
    }
  }
}
